export const eavestroughSchema = [
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.saskroofingcompany.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Services",
        item: "https://www.saskroofingcompany.com/services",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Eavestrough & Gutters",
        item: "https://www.saskroofingcompany.com/services/eavestrough",
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": "https://www.saskroofingcompany.com/services/eavestrough#service",
    serviceType: "Eavestrough Installation",
    name: "Eavestrough",
    description:
      "Seamless eavestrough and gutter installation in Saskatchewan. Protect your foundation with properly sloped, durable gutter systems.",
    url: "https://www.saskroofingcompany.com/services/eavestrough",
    provider: {
      "@id": "https://www.saskroofingcompany.com/#localbusiness",
      "@type": "RoofingContractor",
      name: "Sask Roofing Company",
      url: "https://www.saskroofingcompany.com/",
      telephone: "+1-639-739-7969",
    },
    areaServed: [
      {
        "@type": "City",
        name: "Saskatoon",
        containedInPlace: { "@type": "State", name: "Saskatchewan" },
      },
      {
        "@type": "City",
        name: "Regina",
        containedInPlace: { "@type": "State", name: "Saskatchewan" },
      },
      {
        "@type": "City",
        name: "Moose Jaw",
        containedInPlace: { "@type": "State", name: "Saskatchewan" },
      },
      {
        "@type": "City",
        name: "Prince Albert",
        containedInPlace: { "@type": "State", name: "Saskatchewan" },
      },
      {
        "@type": "City",
        name: "Swift Current",
        containedInPlace: { "@type": "State", name: "Saskatchewan" },
      },
      {
        "@type": "City",
        name: "Yorkton",
        containedInPlace: { "@type": "State", name: "Saskatchewan" },
      },
      {
        "@type": "City",
        name: "Estevan",
        containedInPlace: { "@type": "State", name: "Saskatchewan" },
      },
      {
        "@type": "City",
        name: "Weyburn",
        containedInPlace: { "@type": "State", name: "Saskatchewan" },
      },
    ],
    offers: {
      "@type": "AggregateOffer",
      priceCurrency: "CAD",
      lowPrice: "1200",
      highPrice: "2500",
    },
    availableChannel: {
      "@type": "ServiceChannel",
      serviceUrl: "https://www.saskroofingcompany.com/contact",
      servicePhone: {
        "@type": "ContactPoint",
        telephone: "+1-639-739-7969",
        contactType: "customer service",
        areaServed: "CA-SK",
        availableLanguage: "English",
      },
    },
    termsOfService: "https://www.saskroofingcompany.com/about#warranty",
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      reviewCount: "87",
      bestRating: "5",
      worstRating: "1",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Why are seamless eavestroughs better?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Seamless eavestroughs are custom-cut on site to the exact length of your roofline. Because they have no seams (except at corners), they are far less likely to leak or sag over time.",
        },
      },
      {
        "@type": "Question",
        name: "Do you install leaf guards?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, we can install premium gutter guards that keep leaves and debris out while allowing water to flow freely, reducing your maintenance needs.",
        },
      },
      {
        "@type": "Question",
        name: "Can you install gutters at the same time as a new roof?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Absolutely. It's often the best time to upgrade your eavestroughs. We can coordinate the roof replacement and gutter installation for a seamless exterior upgrade.",
        },
      },
    ],
  },
];
